import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	color: ${CSSVars.gray900};
	max-width: 1420px;
	margin: 0 auto;

	padding: 50px 20px;

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 100px 40px;
	}

	h2 {
		margin: 0 auto 50px;
		font-size: ${CSSVars.fontSize2XL};
		text-align: center;
		font-weight: 600;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: ${CSSVars.fontSize3XL};
		}

		span {
			color: ${CSSVars.blue};
		}
	}

	.benefits {
		display: flex;
		flex-wrap: wrap;
		gap: 50px;

		.card {
			flex: 300px;

			h3 {
				font-size: ${CSSVars.fontSizeLG};
				margin-bottom: 10px;
				font-weight: 500;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSizeXL};
				}
			}

			p {
				font-size: ${CSSVars.fontSizeMD};
				font-weight: 300;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSizeMD};
				}
			}
		}
	}

	/* ============================================================
	   Branded variant — used when overrideBenefits is provided
	   (instagram-feed). Matches the InstagramFeedBenefits visual
	   language: 2x2 grid, gray-pill icons, gradient flip on hover,
	   unified typography with the rest of the new sections.
	   ============================================================ */
	&.branded {
		max-width: 1240px;
		padding: 70px 20px;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			padding: 90px 30px;
		}
		@media screen and (min-width: ${CSSVars.breakpointLG}) {
			padding: 110px 40px;
		}

		h2 {
			font-family: ${CSSVars.primaryFont};
			font-weight: 700;
			font-size: 30px;
			line-height: 1.15;
			letter-spacing: -0.02em;
			color: ${CSSVars.black};
			margin: 0 auto 48px;
			max-width: 820px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: 40px;
				margin-bottom: 56px;
			}
			@media screen and (min-width: ${CSSVars.breakpointLG}) {
				font-size: 48px;
				margin-bottom: 64px;
			}
		}

		.benefits {
			display: grid;
			grid-template-columns: 1fr;
			gap: 18px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				grid-template-columns: repeat(2, 1fr);
				gap: 24px;
			}

			.card {
				flex: unset;
				background: ${CSSVars.white};
				border: 1px solid ${CSSVars.gray100};
				border-radius: 18px;
				padding: 28px;
				display: flex;
				flex-direction: column;
				gap: 14px;
				transition: box-shadow 0.25s ease, transform 0.25s ease,
					border-color 0.25s ease;
				position: relative;
				overflow: hidden;

				@media screen and (min-width: ${CSSVars.breakpointLG}) {
					padding: 36px 32px;
				}

				&::before {
					content: "";
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					height: 3px;
					background: linear-gradient(
						270deg,
						${CSSVars.pink300} 0%,
						${CSSVars.purple500} 50%,
						${CSSVars.blue500} 100%
					);
					opacity: 0;
					transition: opacity 0.25s ease;
				}

				&:hover {
					transform: translateY(-3px);
					box-shadow: 0 16px 36px rgba(16, 24, 40, 0.08);
					border-color: ${CSSVars.gray200};

					&::before {
						opacity: 1;
					}

					.icon {
						background: linear-gradient(
							135deg,
							${CSSVars.blue500} 0%,
							${CSSVars.purple500} 50%,
							${CSSVars.pink300} 100%
						);
						color: ${CSSVars.white};
						border-color: transparent;
					}
				}

				.icon {
					display: inline-flex;
					align-items: center;
					justify-content: center;
					width: 56px;
					height: 56px;
					border-radius: 14px;
					background: ${CSSVars.gray50};
					color: ${CSSVars.blue500};
					border: 1px solid ${CSSVars.gray100};
					transition: background 0.25s ease, color 0.25s ease,
						border-color 0.25s ease;
					flex-shrink: 0;
				}

				h3 {
					font-family: ${CSSVars.primaryFont};
					font-weight: 600;
					font-size: 19px;
					line-height: 1.3;
					letter-spacing: -0.01em;
					color: ${CSSVars.black};
					margin: 0;

					@media screen and (min-width: ${CSSVars.breakpointMD}) {
						font-size: 21px;
					}
				}

				p {
					font-family: ${CSSVars.secondaryFont};
					font-weight: 400;
					font-size: 15px;
					line-height: 1.65;
					color: #4b5563;
					margin: 0;
				}
			}
		}
	}
`;
